import { render, staticRenderFns } from "./uda.vue?vue&type=template&id=235929da&"
import script from "./uda.vue?vue&type=script&lang=js&"
export * from "./uda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports